import { Component, Input, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { HtmlPreviewDialogComponent } from '../preview-dialog/html-preview-dialog.component';

@Component({
  selector: 'app-form-field-html',
  styleUrls: ['./html-form-field.component.scss'],
  templateUrl: './html-form-field.component.html',
  standalone: false,
})
export class HtmlFormFieldComponent extends DataTypeComponent implements OnDestroy {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  constructor(private dialog: MatDialog) {
    super();
  }

  ngOnDestroy() {}

  openDialog(): void {
    const dialogRef = this.dialog.open(HtmlPreviewDialogComponent, {
      maxWidth: '90vw',
      height: '90vh',
      data: { html: this.data },
    });
  }
}
